<template>
  <div :class="video_popup_class">
    <!--      <div  v-if="show_instructions" class="dummy text-md py-2 mt-8 mb-auto inline-block">&nbsp;</div>-->
    <div class="popup_video_container relative" v-if="!has_link">
      <div class="scroll-helper">
        <img :src="img_src" :style="img_style" />
      </div>
    </div>
    <div class="popup_video_container relative" v-if="has_link">
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <div class="scroll-helper" @click="prevent_close($event)">
        <a :href="link_src" target="_blank"
          ><img :src="img_src" :style="img_style"
        /></a>
      </div>
    </div>

    <!--      <div v-if="show_instructions" class="app-popup-instructions text-gray-100 text-sm px-12 py-2 text-md w-18 rounded-full inline-block mb-8 bg-black self-center mt-auto">-->
    <!--        <span>The image will close automatically after a few seconds.</span>-->
    <!--      </div>-->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "sub_image",
  props: ["item"],
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "sections_content",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/image";

      return str;
    },
    img_style() {
      let style = {};

      if ("undefined" != typeof this.getCurrentSectionContent().style) {
        style = this.getCurrentSectionContent().style;
      }
      return style;
    },
    img_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/pdf/" +
        this.item.filename
      );
    },
    link_src() {
      return this.getCurrentSectionContent().link;
    },
    has_link() {
      return (
        "undefined" != typeof this.getCurrentSectionContent().link &&
        this.getCurrentSectionContent().link.length > 0
      );
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return (
        undefined != typeof this.$store.state.popup_img_src &&
        this.$store.state.popup_img_src != ""
      );
    },
    video_popup_class() {
      return "internal-image ";
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    }
  },
  mounted() {}
};
</script>
<style scoped>
.scroll-helper {
  max-height: 90vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/subpopups/image.vue